import { render, staticRenderFns } from "./Encuestas-create.vue?vue&type=template&id=7483a91b&scoped=true&"
import script from "./Encuestas-create.vue?vue&type=script&lang=js&"
export * from "./Encuestas-create.vue?vue&type=script&lang=js&"
import style0 from "./Encuestas-create.vue?vue&type=style&index=0&id=7483a91b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7483a91b",
  null
  
)

export default component.exports